import { Button, Tooltip, Typography } from 'antd';
import { ArrowRightOutlined, PlayCircleOutlined } from '@ant-design/icons';
import { computeHint, type PipelineHintProps } from './pipelineHintModel';

export type { PipelineHintModel, PipelineHintProps } from './pipelineHintModel';

const { Text } = Typography;

/**
 * The "now what?" answer, computed from the live pipeline state and always visible in the
 * toolbar: after any edit the designer TELLS the operator the next step of the governed
 * pipeline (Save → Validate → Publish, with maker-checker where the change class demands it)
 * instead of leaving four equally-lit buttons to guess between. One hint, the next action
 * only — never a lecture. At the end of the pipeline the next action is to RUN the flow.
 */
export function PipelineHint(props: PipelineHintProps) {
  const hint = computeHint(props);
  if (!hint) return null;
  const runnable = hint.action === 'run' && props.onRunNow;
  return (
    <Tooltip title={hint.detail} placement="bottomRight">
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
          padding: '2px 10px',
          borderRadius: 999,
          border: '1px solid var(--ol-border)',
          background: 'var(--ol-bg-base)',
          maxWidth: 480,
        }}
        aria-live="polite"
      >
        <ArrowRightOutlined style={{ fontSize: 11, color: 'var(--ol-primary)' }} />
        <Text style={{ fontSize: 12 }} ellipsis>
          {hint.text}
        </Text>
        {runnable && (
          <Button
            size="small"
            type="link"
            icon={<PlayCircleOutlined />}
            onClick={props.onRunNow}
            style={{ padding: '0 4px', height: 20, fontSize: 12 }}
          >
            Run it now
          </Button>
        )}
      </span>
    </Tooltip>
  );
}
